import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.desktop.header.background};

  display: flex;
  flex-direction: column;
  justify-content: center;
  height: ${({ theme }) => theme.desktop.header.height}px;
  width: 100%;

  box-shadow: 0 6px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);

  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const Logo = styled.img`
  height: 40px;
  margin: 10px 10px 10px 0;
`;

export const HeaderSection = styled.div`
  flex: 1;
  align-self: center;
`;

export const Message = styled.span`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.5px;
  color: ${ColorPalette.HEX.OuterSpace};
`;
